<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <wbo-date-range-report-criteria></wbo-date-range-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-rows>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-entity-group-by-report-criteria [showNoGroupOption]="false" [showInventoryOption]="true"
                                                                     [showSupplierOption]="true"></wbo-entity-group-by-report-criteria>
                            </fui-column>
                            <fui-column>
                                <wbo-entity-sub-group-by-report-criteria
                                    [showInventoryGroupOption]="showInventoryGroupOption"></wbo-entity-sub-group-by-report-criteria>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row>
                        <fui-column>
                            <wbo-checkbox-edit-control [(ngModel)]="model.data.includeStockNotRequired"
                                                       formControlName="includeStockNotRequired">
                            </wbo-checkbox-edit-control>
                        </fui-column>
                    </fui-row>
                </fui-rows>
            </fui-row>
            <fui-row>
                <wbo-inventory-report-selection></wbo-inventory-report-selection>
            </fui-row>
            <fui-row>
                <wbo-supplier-report-selection fieldName="suppliers"></wbo-supplier-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
